import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import SocialIcons from './SocialIcons';

function Menu() {
    const elements = [
        {
            name: 'INÍCIO',
            path: '/'
        }, 
        {
            name: 'SOBRE',
            path: '/sobre'
        }, 
        {
            name: 'PROJETOS',
            path: '/projetos'
        },
        {
            name: 'CONTATO',
            path: '/contato'
        },
    ];

    return (
        <>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="menu">
                <Nav className="mx-auto">
                    {elements.map((element, index) => (
                        <Nav.Link key={index} href={element.path} style={{ color: '#FFF' }}>{element.name}</Nav.Link>
                    ))}
                </Nav>
            </Navbar.Collapse>
        </>
    );
}

export default Menu;
